export default "__VITE_ASSET__BabCExJ6__"